<script setup>
import { computed } from 'vue';
import FamilyPage from '@/components/result/ai-literacy-2026/FamilyPage.vue';

const props = defineProps({
    studentData: Object
});

const schulType = computed(() => props.studentData?.schul_type || 'E');
</script>
<template>
    <FamilyPage :schulType="schulType" />
</template>
